import { useTranslation } from 'react-i18next';

export type ComposerMode = 'illustration' | 'biopolymer';

interface ComposePanelProps {
  readonly onCompose: (mode: ComposerMode) => void;
}

// ADR 0007 P10b — the COMPOSE tab: launchers for the full-screen composers (Q5: no docking).
// #705: reactions are composed on the drawing paper itself (ADR 0014) -- the reaction composer
// and its participant picker are retired.
export function ComposePanel({ onCompose }: ComposePanelProps) {
  const { t } = useTranslation();

  return (
    <div className="workspace-compose">
      <section className="isomer-picker" aria-label={t('app.illustrationEntryAriaLabel')}>
        <h2>{t('app.illustrationHeading')}</h2>
        <p>{t('app.illustrationSubheading')}</p>
        <button type="button" onClick={() => onCompose('illustration')}>
          {t('app.composeIllustration')}
        </button>
      </section>

      <section className="isomer-picker" aria-label={t('app.biopolymerEntryAriaLabel')}>
        <h2>{t('app.biopolymerHeading')}</h2>
        <p>{t('app.biopolymerSubheading')}</p>
        <button type="button" onClick={() => onCompose('biopolymer')}>
          {t('app.composeBiopolymer')}
        </button>
      </section>
    </div>
  );
}
